export default __webpack_public_path__ + "static/media/Solutions & Support - img.361baf90.png";